module.exports = __webpack_public_path__ + "img/bnr_yid_sp.bbfdcb00.jpg";